import React from "react"

import { Number } from "@tenforce/product-fields"

import { setCurrentFieldInEditMode, updateField } from "../../slice"
import { useAppDispatch, useAppSelector } from "../../../../hooks"
import HTMLAndInternalLinkParser from "../common/HTMLAndInternalLinkParser"
import { Labels } from "../../../../util/Translations"
import { INumberField } from "../../index"
import { GlobalState } from "../../../../store"

export interface Props {
    field: INumberField
}

export const NumberField = ({ field }: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const { isLoading: isFieldLoading, currentFieldInEditMode = "" } =
        useAppSelector((state: GlobalState) => state.fields)
    const regionalDecimalSeparator = useAppSelector(
        (state: GlobalState) =>
            state.userFormattingSettings.numberFormat.decimalSeparator,
    )

    const {
        position: _position,
        odataType: _odataType,
        isAutoCompleteEnabled,
        itemId,
        value,
        maxNumberOfIntegerDigits,
        maxNumberOfDecimalDigits,
        ...fieldProps
    } = field

    const { ClickHereToEdit } = Labels

    const isLoading = fieldProps.isLoading || isFieldLoading

    const isDisabled =
        fieldProps.isDisabled ||
        !["", fieldProps.fieldId].includes(currentFieldInEditMode)

    return (
        <Number
            {...fieldProps}
            regionalDecimalSeparator={regionalDecimalSeparator}
            isLoading={isLoading}
            description={
                <HTMLAndInternalLinkParser
                    content={(field?.description as string) ?? ""}
                />
            }
            value={value}
            maxWholeDigits={maxNumberOfIntegerDigits}
            maxDecimalDigits={maxNumberOfDecimalDigits}
            placeholder={ClickHereToEdit}
            onSave={async (newValue: number): Promise<void> => {
                if (newValue === value) {
                    return
                }
                await dispatch(
                    updateField({
                        field,
                        newValue,
                    }),
                ).unwrap()
            }}
            isDisabled={isDisabled}
            onFieldEnterEditMode={(fieldId): void => {
                dispatch(
                    setCurrentFieldInEditMode(fieldId ?? fieldProps.fieldId),
                )
            }}
            onFieldExitEditMode={(): void => {
                dispatch(setCurrentFieldInEditMode(""))
            }}
        />
    )
}

export default NumberField
